import { Skeleton } from '@/components/ui/skeleton';
import { Box, HStack, VStack } from '@chakra-ui/react';
import React from 'react';

interface SentBatchListSkeletonProps {
  count?: number;
}

const SentBatchListSkeleton: React.FC<SentBatchListSkeletonProps> = ({ count = 4 }) => {
  return (
    <VStack gap="1px" align="stretch" w="full">
      {Array.from({ length: count }).map((_, i) => (
        <Box key={i} py={2.5} px={2.5}>
          <HStack justify="space-between" mb={1}>
            <Skeleton height="14px" width={`${100 + (i % 3) * 30}px`} />
            <Skeleton height="12px" width="40px" />
          </HStack>
          <Skeleton height="12px" width="60%" mb={1.5} />
          <HStack gap={1}>
            {[0, 1, 2].map((j) => (
              <Skeleton
                key={j}
                height="20px"
                width="20px"
                rounded="full"
                ml={j > 0 ? '-6px' : '0'}
              />
            ))}
            <Skeleton height="12px" width="70px" ml={2} />
          </HStack>
        </Box>
      ))}
    </VStack>
  );
};

export default SentBatchListSkeleton;
